import { EdmontonSource } from './../../app-config.constants';
import { ContactFormLocationType, ListingSource } from './../../classes/enums';
import { caraBoardPartialName,
    victoriaRealEstate,
    RowTitleBoard,
    DisableSellersLeadFormStateShorts,
    Disclaimer,
    CreaBoardName} from '../../app-config.constants';
import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, Renderer2, ViewChild, AfterViewInit } from '@angular/core';
import { ListingsService } from '../../services/listings.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Listing } from '../../classes/listing';
import { UserService } from '../../services/user.service';
import { PreferencesService } from '../../services/preferences.service';
import { TranslateService } from '@ngx-translate/core';
import { HasSubscriptions } from '../has-subscriptions';
import { timer, merge, combineLatest} from 'rxjs';
import {delay, skip, take, takeWhile} from 'rxjs/operators';
import { ListingCategory, ListingTypeMap, SCREEN_SIZE, ViewModes } from '../../classes/enums';
import { AccordionComponent } from '../../shared/components/accordion/accordion.component';
import { Filters } from '../../classes/user-preferences';
import { HasMinMax } from '../forms/min-max-slider/min-max-slider.component';
import { User } from '../../classes/user';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { CommunicationService } from '../../services/communication.service';
import { Pagination } from '../../classes/pagination';
import { HistoryItem } from '../../classes/history-item';
import { PreRenderService } from '../../services/pre-render.service';
import { RoutingHistoryService } from '../../services/routing-history.service';
import { MetaTagService } from '../../services/meta-tag.service';
import { DomManipulationService } from '../../services/dom-manipulation/dom-manipulation.service';
import { StyleService } from '../../services/style/style.service';
import { Agent } from '../../classes/agent';
import { BlogPostSourcePage } from '../../classes/enums';
import { BlogService } from '../../services/blog.service';
import get from 'lodash-es/get';
import { IBlogResponse, IBlogItem } from '../../classes/interfaces';
import LatLngLiteral = google.maps.LatLngLiteral;
import { LOCALLOGIC_SCRIPT, CLIPBOARD_SCRIPT } from '../../classes/dynamicScripts';
import { emailRegex, nameRegex, RemaxLeadEntity, MapAgentToLead, LeadTrigger } from '../../classes/leads';
import { DemographicsService } from '../../services/demographics.service';
import { AgentService } from '../../services/agent.service';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { OFFMARKET_SEARCH_MORE } from '../../classes/analytics-tags';
import { TitleCasePipe } from '@angular/common';
import { ListingPageView } from '../../classes/listing-page-view'

declare var Clipboard: any;
declare var locallogic: any;
@Component({
  selector: 'app-listing-details',
  templateUrl: './listing-details.component.html',
  styleUrls: [
    './listing-details.component.scss',
    './listing-details.desktop.component.scss',
    './listing-details.mobile.component.scss'
  ],
})
export class ListingDetailsComponent extends HasSubscriptions implements OnInit, OnDestroy, AfterViewInit {
  ad: IBlogItem;
  tdAd: string;
  contactFormTitle: string;
  @Output() unfavourited = new EventEmitter<void>();
  @ViewChild('accordion') accordion: AccordionComponent;
  @ViewChild('collapseDetailSectionsRef') collapseDetailSectionsRef: ElementRef;
  @ViewChild('contactAgentModal') contactAgentModal: ElementRef;
  @ViewChild('offMarketAskQuestionModal') offMarketAskQuestionModalRef: ElementRef;
  modalTemplateRef: ElementRef;

  ListingSource = ListingSource;
  BlogPostSourcePage = BlogPostSourcePage;

  listing: Listing = new Listing();
  showMore: boolean = false;
  contactAgent: boolean = false;
  moreInfoRequested: string[];
  favourites: Array<string> = [];
  hasCopiedText: boolean = false;
  isLoading: boolean = true;
  mortgagePaymentAmount: string = '$0';
  isCreaListing = false;
  nextListings: Array<{ listingId: string, detailUrl: string }> = [];
  hasMoreListings: boolean = false;
  additionalOffset: number;
  showPOI: boolean = true;
  locallogic: any;
  suggestedListings: Listing[] = [];
  creaDisclaimer = Disclaimer.crea.disclaimer;
  creaDisclosure = Disclaimer.crea.disclosure;
  isMortgageApplicable: boolean;

  householdSizeGraphVisible = 0;
  householdIncomeGraphVisible = 0;
  maritalStatusGraphVisible = 0;
  showRequestSent: boolean = false;
  listingCategory: ListingCategory;
  showMap: boolean = false;
  sessionEmail = '';
  contactForm: FormGroup;
  showExpandedGalleryView: boolean = false;
  shouldShowInitials: boolean = false;
  hasRetrievedSuggestedListings = false;

  screenSize: SCREEN_SIZE;

  priceOrPricePerSqFt: string;

  centerLatLng: LatLngLiteral;

  // If they have a favourite agent, we need to handle this separately
  favouriteAgent: Agent;
  agentOnContactForm: Agent;

  customLeadInfo: Partial<RemaxLeadEntity> = {
    triggerType: LeadTrigger.RequestInfo,
  };


  // We only show this if they don't have a favourite agent, or the favourite agent is the same as the listing agent
  shouldShowContactAgentHeaderTemplate: boolean = true;


  private _user: User;
  private _clipboardObj;
  private _nextListingsOffset: number = 0;
  private _activeViewMode: ViewModes;

  private _pagination: Pagination = new Pagination();
  private _contactFormMessages = []; // We fill this up so we dont do multiple translations calls

  // enums:
  ListingCategory = ListingCategory;
  SCREEN_SIZE = SCREEN_SIZE;

  activeContactFormLocationType: ContactFormLocationType = null;
  ContactFormLocationType = ContactFormLocationType;
  ownRentChart: any;

  private showFeatures: boolean;
  isVictoriaRealEstateBoard: boolean = false;
  isCaraBoard: boolean = false;
  isEdmontonBoard: boolean = false;

  customMapOptions = {
    zoomControl: false,
    streetViewControl: false,
    zoom: 14,
    draggable: false,
    scrollwheel: false,
  };
  suggestedListingSearchUrl: string;
  disableSellersLeadForm: boolean;

  listingPageView = new ListingPageView();

  constructor(private listingService: ListingsService,
    private communicationService: CommunicationService,
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private _preferencesService: PreferencesService,
    private translateService: TranslateService,
    private renderer: Renderer2,
    private blogService: BlogService,
    private router: Router,
    public prerenderService: PreRenderService,
    private titlecasePipe: TitleCasePipe,
    private historyService: RoutingHistoryService,
    private domManipulationService: DomManipulationService,
    private metaTagService: MetaTagService,
    private styleService: StyleService,
    private demographicsService: DemographicsService,
    private agentService: AgentService,
    protected _analyticsService: AnalyticsService
  ) {
    super();

    this.contactForm = new FormGroup({
      name: new FormControl('', { validators: [Validators.required, Validators.pattern(nameRegex)], updateOn: 'blur' }),
      email: new FormControl('', { validators: [Validators.required, Validators.pattern(emailRegex)], updateOn: 'blur' }),
      contactByPhone: new FormControl(false),
      contactType: new FormControl('text'),
      buy: new FormControl(false),
      sell: new FormControl(false),
      comments: new FormControl(''),
      phone: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(13)]),
      weekdayMorning: new FormControl(false),
      weekdayAfternoon: new FormControl(false),
      weekdayEvening: new FormControl(false),
      weekendMorning: new FormControl(false),
      weekendAfternoon: new FormControl(false),
      weekendEvening: new FormControl(false),
      requestMoreInfo: new FormControl(false),
      findSimilarHomes: new FormControl(false),
      sellAProperty: new FormControl(false)
    });


    const contactByPhoneFormControl = this.contactForm.controls['contactByPhone'];
    const phoneFormControl = this.contactForm.controls['phone'];
    contactByPhoneFormControl.valueChanges.subscribe((value) => {
      if (value) phoneFormControl.enable();
      else phoneFormControl.disable();
      phoneFormControl.updateValueAndValidity();
    });
    merge(this.contactForm.get('buy').valueChanges, this.contactForm.get('sell').valueChanges).pipe(takeWhile(() => this.listing && !this.listing.isOffMarket)).subscribe(() => this._setCommentsMessage());
    merge(this.contactForm.get('requestMoreInfo').valueChanges,
          this.contactForm.get('findSimilarHomes').valueChanges,
          this.contactForm.get('sellAProperty').valueChanges).pipe(takeWhile(() => this.listing && this.listing.isOffMarket)).subscribe(() => this._setCommentsMessageForOffMarket());
    merge(this.contactForm.get('weekdayMorning').valueChanges,
          this.contactForm.get('weekdayAfternoon').valueChanges,
          this.contactForm.get('weekdayEvening').valueChanges,
          this.contactForm.get('weekendMorning').valueChanges,
          this.contactForm.get('weekendAfternoon').valueChanges,
          this.contactForm.get('weekendEvening').valueChanges).subscribe(() => this._setCommentsMessageForScheduleAViewing());
  }

  ngOnInit() {
    this._loadScripts();

    this.addSub(this.activatedRoute.data.subscribe(async ({ user, listing, screenSize }) => {
      this._user = user;
      this.screenSize = screenSize;
      await this._setListingDetails(listing);
      this.getDemographics();
      this.getNeighbourhood();
    }));

    this.addSub(this.communicationService.listings.listingCategory.subscribe((selectedListingType) => {
      this.listingCategory = selectedListingType;
    }));

    this.addSub(this._preferencesService.viewModesChanged.subscribe(mode => this._activeViewMode = mode));

    // Skip the first one since the resolver has it
    this.addSub(this.communicationService.screenSize.pipe(skip(1)).subscribe((s) => this.screenSize = s));

    this.addSub(this._preferencesService.favouriteListingsChanged.subscribe((favourites) => this.favourites = favourites));

    this.addSub(this.userService.currentUser.subscribe((s) => {
      this._user = s;
      this.sessionEmail = s.email;
      if (this._user.email) {
        this.getFavouriteAgent(s && s.preferences.favouriteAgents && s.preferences.favouriteAgents.length ? s.preferences.favouriteAgents[0] : null)
        this.contactForm.patchValue({
          email: this._user.email,
          name: this._user.name,
          buy: this._user.buy,
          sell: this._user.sell,
          phone: this._user.phoneNumber
        });
      }
    }));

    this.addSub(this._preferencesService.moreInfoRequestedChanged.subscribe(moreInfoRequested => this.moreInfoRequested = moreInfoRequested));

    const cmsTag = this.listing.isCommercial ? 'cms-listing-details-comm-side' : 'cms-listing-details-side';
    this.blogService.getByTags(['cms-listing-details-TD', cmsTag]).toPromise()
      .then((results: IBlogResponse[]) => {
        if (results && results.length) {
          const tdAd = results.filter(r => r.tag === 'cms-listing-details-TD');
          if (tdAd && tdAd.length) {
            this.tdAd = get(tdAd, '[0].content.content.rendered');
          }
          const sideAd = results.filter(r => r.tag === cmsTag);
          if (sideAd && sideAd.length) {
            this.ad = get(sideAd, '[0].content');
          }
        }
      });

    this.getCmsLinks();
    // Check if we need to wait for the Clipboard javascript to load before instantiating it.
    this.domManipulationService.loadScript(CLIPBOARD_SCRIPT).subscribe(() => {
      const ok = Clipboard.isSupported();
      // If the line above was successful, the javascript is loaded.
      if (ok) this._instantiateClipboard();
    });

    /**
     * Don't show features if board is the only item in it
     */
    this.showFeatures = !(this.listing && this.listing.additionalFeatureRows && this.listing.additionalFeatureRows.length === 1 && this.listing.additionalFeatureRows[0].title.toLowerCase() === RowTitleBoard.lowercase);
    this.isVictoriaRealEstateBoard = this.listing.boardName && this.listing.boardName.toLowerCase().indexOf(victoriaRealEstate) !== -1 && !this.listing.isRemaxListing;
    this.isCaraBoard = this.listing.boardName && this.listing.boardName.toLowerCase().indexOf(caraBoardPartialName) !== -1 ; //&& !this.listing.isRemaxListing;
    this.modalTemplateRef = this.contactAgentModal;

    this.recordAnalytics();
  }

  // MBL-3017: Record listing page view analytic data
  async recordAnalytics() {
    this.listingPageView.listingId = this.listing.listingId;
    this.listingPageView.source = this.listing.source;
    this.listingPageView.mlsNum = this.listing.mlsNum ? this.listing.mlsNum : null;

    if (this.listing.agent && this.listing.agent.personifyId) {
      this.listingPageView.agentPersonifyId = this.listing.agent.personifyId;
      this.listingPageView.agentFirstName = this.listing.agent.firstName;
      this.listingPageView.agentLastName = this.listing.agent.lastName;
      this.listingPageView.agentEmail = this.listing.agent.email;
    }
    else {
      this.listingPageView.agentPersonifyId =
        this.listingPageView.agentFirstName =
        this.listingPageView.agentLastName =
        this.listingPageView.agentEmail = null;
    }

    if (this.listing.coAgent && this.listing.coAgent.personifyId) {
      this.listingPageView.coAgentPersonifyId = this.listing.coAgent.personifyId;
      this.listingPageView.coAgentFirstName = this.listing.coAgent.firstName;
      this.listingPageView.coAgentLastName = this.listing.coAgent.lastName;
      this.listingPageView.coAgentEmail = this.listing.coAgent.email;
    }
    else {
      this.listingPageView.coAgentPersonifyId =
        this.listingPageView.coAgentFirstName =
        this.listingPageView.coAgentLastName =
        this.listingPageView.coAgentEmail = null;
    }

    this.listingPageView.uaid = this.listing.uaid ? this.listing.uaid : null;
    this.listingPageView.uuaid = this.listing.uuaid ? this.listing.uuaid : null;

    const dateNow = new Date();
    this.listingPageView.viewedOn = Date.UTC(
      dateNow.getUTCFullYear(),
      dateNow.getUTCMonth(),
      dateNow.getUTCDate(),
      dateNow.getUTCHours(),
      dateNow.getUTCMinutes(),
      dateNow.getUTCSeconds(),
      dateNow.getUTCMilliseconds()
    ).toString();
    this.listingPageView.detailUrl = this.listing.detailUrl;

    const result = await this.listingService.getClientIPAddress()
      .catch(() => {
        this.listingPageView.clientIPAddress = "IP_BLOCKED";
    });

    if (result && result['ip']) {
      this.listingPageView.clientIPAddress = result['ip'];
    }
    this.listingPageView.isOffMarket = this.listing.isOffMarket;
    return await this.listingService.trackPageView(this.listingPageView)
  }

  getCmsLinks() {
    this.communicationService.footerLinksChange.next({ city: this.listing.city, province: this.listing.province });
  }
  /**
   * One time retrieve the favourite agent by source System ID
   * @param sourceSystemId
   */
  async getFavouriteAgent(sourceSystemId: string) {
    if (sourceSystemId) {
      this.favouriteAgent = await this.agentService.getAgentDetails(sourceSystemId, true).toPromise();
      if (this.favouriteAgent) {
        this._setCommentsMessage(true);
        this.customLeadInfo = MapAgentToLead(this.favouriteAgent);
        this.shouldShowContactAgentHeaderTemplate = this.listing.agent && this.listing.agent.sourceSystemId === this.favouriteAgent.sourceSystemId;
      }
    }
    else {
      this.favouriteAgent = null;
    }
  }


  getDemographics() {
    this.demographicsService.getDemographics(this.listing.lat, this.listing.lng)
      .then((data) => {
        if (data.hasAnyData()) {
          this.listing.demographics = data;
        }
      });
  }

  getNeighbourhood() {
    this.demographicsService.getNeighbourhood(this.listing.lat, this.listing.lng)
      .then((result) => {
        this.listing.neighbourhood = result
      });
  }

  ngAfterViewInit() {
    // TODO Luxury listings don't have POI for now
    if (!this.listing.isLuxury && !this.listing.isOffMarket) {
      // Wait until script is loaded and view is initialized with poiWidget div
      this.addSub(combineLatest(
        this.activatedRoute.data,
        this.domManipulationService.loadScript(LOCALLOGIC_SCRIPT),
      ).pipe(delay(0))
        .subscribe(() => {
          const x = new locallogic.LocalContent('poiWidget', {
            lat: this.listing.lat,
            lng: this.listing.lng,
            color: '#004E9B',
            locale: this.translateService.getBrowserLang(),
            callback: () => this.showPOI = false,
            basemap: 'google'
          });
        }));
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this._clipboardObj) this._clipboardObj.destroy();
    this.communicationService.backToPreviousListingCategory();
  }

  setPriceOrPricePerSqFt() {
    this.listingService.getPriceOrPricePerSqFtString(this.listing).subscribe(str => this.priceOrPricePerSqFt = str);
  }

  showMorePanel() {
    if (this.showMore) {
      this.collapseDetailSectionsRef.nativeElement.scrollIntoView();
    }
    this.showMore = !this.showMore;
  }

  hideContactAgentPopup() {
    this.contactFormTitle = null;
    this.contactAgent = false;
    this.modalTemplateRef = this.contactAgentModal;
    this.styleService.removeClass(this.renderer, 'body', 'with-side-nav');

    const controls = this.contactForm.controls;
    // FIXME: This is a temp hack until can figure out why the modal changes dont propagate
    // Changes to the contactForm in the ng template modal propagate from a data perspective, but the view doesnt update properly
    controls['name'].setValue(controls['name'].value || '');
    controls['email'].setValue(controls['email'].value || '');
    controls['contactByPhone'].setValue(controls['contactByPhone'].value || false);
    controls['contactType'].setValue(controls['contactType'].value || 'text');
    controls['buy'].setValue(controls['buy'].value || false);
    controls['sell'].setValue(controls['sell'].value || false);
    controls['comments'].setValue(controls['comments'].value || '');
    controls['phone'].setValue(controls['phone'].value || '');
    controls['weekdayMorning'].setValue(controls['weekdayMorning'].value || false);
    controls['weekdayAfternoon'].setValue(controls['weekdayAfternoon'].value || false);
    controls['weekdayEvening'].setValue(controls['weekdayEvening'].value || false);
    controls['weekendMorning'].setValue(controls['weekendMorning'].value || false);
    controls['weekendAfternoon'].setValue(controls['weekendAfternoon'].value || false);
    controls['weekendEvening'].setValue(controls['weekendEvening'].value || false);
    controls['requestMoreInfo'].setValue(controls['requestMoreInfo'].value || false);
    controls['findSimilarHomes'].setValue(controls['findSimilarHomes'].value || false);
    controls['sellAProperty'].setValue(controls['sellAProperty'].value || false);
  }

  showContactAgent(agent?: Agent) {
    // $event.stopPropagation();
    // $event.preventDefault();
    this.setFormAgent(agent);
    this._openContactAgent(agent, ContactFormLocationType.LISTING_CONTACT_AGENT);
  }

  onScheduleViewing(agent?: Agent) {
    this.setFormAgentForScheduleViewing(agent);
    this._openContactAgent(agent, ContactFormLocationType.LISTING_SCHEDULE_VIEWING);
  }

  showOffmarketCTA() {
    this.modalTemplateRef = this.offMarketAskQuestionModalRef;
    this.contactForm.controls['requestMoreInfo'].setValue(true);
    this._openContactAgent(null, ContactFormLocationType.LISTING_ASK_QUESTION_OFFMARKET);
  }

  closeOffmarketCTA() {
    this.contactForm.reset();
    this.hideContactAgentPopup();
  }
  /**
   * add the proper agent info to the form. If the user has a favourite agent, then all requests will go directly to that agent.
   * If the user clicks on the co-agent, then the request will go to the co-agent. In every other case the request will go to the main listing agent
   * @param agent
   */
  setFormAgent(agent: Agent) {
    this.agentOnContactForm = agent;
    this.customLeadInfo = this.favouriteAgent ? MapAgentToLead(this.favouriteAgent) : (agent ? MapAgentToLead(agent) : { triggerType: LeadTrigger.RequestInfo });
    this._setCommentsMessage(true);
  }

  setFormAgentForScheduleViewing (agent: Agent) {
    this.agentOnContactForm = agent;
    this.customLeadInfo = this.favouriteAgent ? MapAgentToLead(this.favouriteAgent) : (agent ? MapAgentToLead(agent) : { triggerType: LeadTrigger.RequestInfo });
    this._setCommentsMessageForScheduleAViewing(true);
  }

  onAskQuestion() {
    this._openContactAgent(null, ContactFormLocationType.LISTING_ASK_QUESTION);
  }

  private _openContactAgent(agent: Agent, locationType: ContactFormLocationType) {
    this.activeContactFormLocationType = locationType;
    if (agent) {
      this.contactFormTitle = 'contact.contact';
    }
    this.contactAgent = true;
    this.styleService.addClass(this.renderer, 'body', 'with-side-nav');
  }

  onListingsClicked(listing: Listing) {
    this.contactForm.reset();
    this.suggestedListings = [];
  }

  onChartClick(event) {
  }

  switchGraph(property: string, value) {
    if (property === 'householdSize') {
      this.householdSizeGraphVisible = value;
    } else if (property === 'householdIncome') {
      this.householdIncomeGraphVisible = value;
    } else if (property === 'maritalStatus') {
      this.maritalStatusGraphVisible = value;
    }
  }
  goToPoi() {
    // TODO: make this smooth
    const top = document.getElementById('poiWidget').offsetTop;
    // TODO: make the first input focused on the contact form
    this.domManipulationService.scrollTo(0, top);
  }

  toggleMap() {
    this.showMap = !this.showMap;
    this.domManipulationService.scrollToTop();
  }

  showGalleryView() {
    if (this.showMap) {
      this.toggleMap()
    }
    this.showExpandedGalleryView = true;
  }

  navigateToContactAgentForm(agent) {
    this.setFormAgent(agent);
    document.getElementById('contact-form').scrollIntoView(true);
  }

  get agentToContactName(): string {
    // TODO: Translation
    return this.favouriteAgent ? this.favouriteAgent.firstName : (this.listing.agent ? this.listing.agent.firstName : 'A RE/MAX Agent');
  }

  async goToNextListing($event) {
    this.contactForm.reset();
    if ($event) $event.stopPropagation();
    if (this.nextListings.length <= 0) return;
    this._nextListingsOffset++;
    if (this._nextListingsOffset >= this.nextListings.length) {
      // go back to the beginning of the list
      this._nextListingsOffset = 0;
    }
    const nextListingUrl = this.nextListings[this._nextListingsOffset].detailUrl;
    this.router.navigate([nextListingUrl]);
  }

  async goToPreviousListing($event) {
    this.contactForm.reset();
    if ($event) $event.stopPropagation();
    if (this.nextListings.length <= 0) return;
    this._nextListingsOffset--;
    if (this._nextListingsOffset < 0) {
      // go to the end of the list
      this._nextListingsOffset = this.nextListings.length - 1;
    }
    const nextListingUrl = this.nextListings[this._nextListingsOffset].detailUrl;
    this.router.navigate([nextListingUrl]);
  }

  private async _getMoreListings() {
    // On server we don't need to populate gallery listings
    if (this.prerenderService.isServerMode) {
      this.hasMoreListings = false;
      return;
    }

    // If gallery, we have to double check if there's any more listings to be shown or not, since from the gallery, listings are paginated
    if (this._activeViewMode === ViewModes.GALLERY) {
      while (true) {
        const response = await this.listingService.searchListingsGallery(this._pagination, null);
        if (response === null || response.results === null) {
          // if there's no more results, clear out the list
          this.nextListings = [];
          this._preferencesService.addNextListings(this.nextListings);
          return;
        } else {
          // make sure we only get results that we don't already have
          const newPage = response.results.filter(l => this.nextListings.map(listing => l.listingId).indexOf(l.listingId) < 0);
          this._pagination.pageNumber++;
          if (!newPage || newPage.length === 0) continue;
          // update the list and send it to the service because activateRoute will be called again
          this.nextListings = this.nextListings.concat(newPage.map((l) => ({ listingId: l.listingId, detailUrl: l.detailUrl })));
          this._preferencesService.addNextListings(this.nextListings);
          break;
        }
      }
      this.hasMoreListings = true;
    }
  }

  private _instantiateClipboard() {
    this._clipboardObj = new Clipboard('.clipboard-text');
    this._clipboardObj.on('success', (e) => {
      this.hasCopiedText = true;
      timer(2000).subscribe(() => this.hasCopiedText = false);
    });
    this._clipboardObj.on('error', (e) => console.error(e));
  }

  // TODO: Maybe make a loading animation in the html
  private _getSuggestedListings() {
    this.hasRetrievedSuggestedListings = false;

    this.suggestedListings = [];
    /**
      * Show suggested listings that are:
      * 1) within 10km
      * 2) within +/- 5% of current listing price
      * 3) Within same property type
      */
    const customFilters: Filters = new Filters();
    customFilters.customListingTypeIds = [this.listing.listingTypeId];

    const plusMinusPriceMultiplier = this.listing.isCommercial ? 0.25 : 0.05;

    customFilters.price = {
      min: this.listing.listPrice - (this.listing.listPrice * plusMinusPriceMultiplier),
      max: this.listing.listPrice + (this.listing.listPrice * plusMinusPriceMultiplier)
    } as HasMinMax;

    customFilters.businessTypes = this.listing;
    let distanceToSearchInMetres = 10000;

    if (this.listing.isCommercial) {
      distanceToSearchInMetres = 50000;

      if (this.listing.pricePerSqFt > 0) {
        customFilters.pricePerSqFt = {
          min: this.listing.pricePerSqFt - 25,
          max: this.listing.pricePerSqFt + 25
        } as HasMinMax;
        customFilters.price = {};
      }
      customFilters.customListingTypeIds = ListingTypeMap.commercial.reduce((a, b) => a.concat(b), []);
    }
    this.listingService.getListingsByDistanceFrom(new Pagination(), customFilters, this.centerLatLng, distanceToSearchInMetres).then((response) => {
      this.suggestedListings = response.results;
      this.hasRetrievedSuggestedListings = true;
      // Remove the current element if its in the list
      this.suggestedListings = this.suggestedListings.filter((l) => l.listingId !== this.listing.listingId);
    });
  }

  private _updateAgentInformation() {
    if (this.listing.agent) {
      this.listing.agent.personifyId = this.listing.remaxAgentId;
      this.listing.agent.sourceSystemId = this.listing.remaxAgentSourceSystemId;
    }
    if (this.listing.coAgent) {
      this.listing.coAgent.personifyId = this.listing.remaxCoAgentId;
      this.listing.coAgent.sourceSystemId = this.listing.remaxCoAgentSourceSystemId;
    }
    this.shouldShowContactAgentHeaderTemplate = !!this.listing.agent;
  }

  /**
   * Override the conditions that we normally check against to update the contact agent comments message in the form
   */
  private _setCommentsMessage(forceOverride: boolean = false) {
    if (!this.listing.address || !this.priceOrPricePerSqFt) return;
    const translateParams = {
      agent: this.favouriteAgent ? this.favouriteAgent.firstName : this.agentOnContactForm ? this.agentOnContactForm.firstName : (this.listing.agent ? this.listing.agent.firstName : ''),
      address: this.listing.address,
      price: this.priceOrPricePerSqFt
    };
    if (this._contactFormMessages.length === 0 || forceOverride) {
      // Avoid making multiple calls to the translate service to get the translations
      this.translateService.get(['contact.contact-buy-favourite-agent', 'contact.contact-buy', 'contact.contact-sell', 'contact.contact-buy-sell'], translateParams)
        .toPromise().then(translations => {
          const buyMessage = translations['contact.contact-buy' + (this.favouriteAgent ? '-favourite-agent' : '')];
          const sellMessage = translations['contact.contact-sell'];
          const buySellMessage = translations['contact.contact-buy-sell'];
          this._contactFormMessages = [];
          this._contactFormMessages.push(buyMessage);
          this._contactFormMessages.push(sellMessage);
          this._contactFormMessages.push(buySellMessage);
          this._selectCommentMessage(forceOverride);
        });
    }
    else {
      this._selectCommentMessage(forceOverride);
    }
  }

  private _setCommentsMessageForScheduleAViewing(forceOverride: boolean = false) {
    if (!this.listing.address) return;
    const translateParams = {
      agent: this.favouriteAgent ? this.favouriteAgent.firstName : this.agentOnContactForm ? this.agentOnContactForm.firstName : (this.listing.agent ? this.listing.agent.firstName : ''),
      address: this.listing.address,
      price: this.priceOrPricePerSqFt,
    };
    if (this._contactFormMessages.length === 0 || forceOverride) {
      // Avoid making multiple calls to the translate service to get the translations
      this.translateService.get(['contact.viewing.schedule-a-viewing', 'contact.viewing.availability',
                                 'contact.viewing.availability-weekdays', 'contact.viewing.availability-weekends',
                                 'contact.viewing.availability-and', 'contact.viewing.morning',
                                 'contact.viewing.afternoon', 'contact.viewing.evening', 'contact.viewing.daily-and'], translateParams)
        .toPromise().then(translations => {
          this._contactFormMessages = [];
          this._contactFormMessages.push(translations['contact.viewing.schedule-a-viewing']);
          this._contactFormMessages.push(translations['contact.viewing.availability']);
          this._contactFormMessages.push(translations['contact.viewing.availability-weekdays']);
          this._contactFormMessages.push(translations['contact.viewing.availability-weekends']);
          this._contactFormMessages.push(translations['contact.viewing.availability-and']);
          this._contactFormMessages.push(translations['contact.viewing.morning']);
          this._contactFormMessages.push(translations['contact.viewing.afternoon']);
          this._contactFormMessages.push(translations['contact.viewing.evening']);
          this._contactFormMessages.push(translations['contact.viewing.daily-and']);
          this._selectCommentMessageForViewing(forceOverride);
        });
    }
    else {
      this._selectCommentMessageForViewing(forceOverride);
    }
  }

  private _selectCommentMessage(forceOverride: boolean = false) {
    const buyMessage = this._contactFormMessages[0];
    const sellMessage = this._contactFormMessages[1];
    const buySellMessage = this._contactFormMessages[2];
    const currentMessage = this.contactForm.controls['comments'].value;
    // the message in the box is one of the default messages
    if (forceOverride || (!currentMessage || (this._contactFormMessages.filter((value) => value === currentMessage)).length)) {
      if (this.contactForm.controls['buy'].value && this.contactForm.controls['sell'].value) {
        this.contactForm.patchValue({ comments: buySellMessage });
      } else if (this.contactForm.controls['sell'].value) {
        this.contactForm.patchValue({ comments: sellMessage });
      } else {
        this.contactForm.patchValue({ comments: buyMessage });
      }
    }
  }

  private _setCommentsMessageForOffMarket(forceOverride: boolean = false) {
    if (!this.listing.address) return;
    const translateParams = {
      address: this.listing.address,
      city: this.listing.city,
      province: this.listing.province,
      postalCode: this.listing.postalCode
    }
    if (this._contactFormMessages.length === 0 || forceOverride) {
      this.translateService.get(['contact.offmarket.comment-section.request-more-info',
                                'contact.offmarket.comment-section.find-similar-homes',
                                'contact.offmarket.comment-section.sell-a-property'], translateParams)
          .toPromise().then(translations => {
            this._contactFormMessages = [];
            this._contactFormMessages.push(translations['contact.offmarket.comment-section.request-more-info']);
            this._contactFormMessages.push(translations['contact.offmarket.comment-section.find-similar-homes']);
            this._contactFormMessages.push(translations['contact.offmarket.comment-section.sell-a-property']);
            this._selectCommentsMessageForOffMarket(forceOverride);
          });
    } else {
      this._selectCommentsMessageForOffMarket(forceOverride);
    }
  }

  private _selectCommentsMessageForOffMarket(forceOverride: boolean = false) {
    const requestMoreInfoMessage = this._contactFormMessages[0];
    const findSimilarHomesMessage = this._contactFormMessages[1];
    const sellAPropertyMessage = this._contactFormMessages[2];
    const currentMessage = this.contactForm.controls['comments'].value;

    if (forceOverride || (!currentMessage || (this._contactFormMessages.filter((value) => value === currentMessage)).length)) {

      const requestMoreInfoChecked = this.contactForm.controls['requestMoreInfo'].value;
      const findSimilarHomesChecked = this.contactForm.controls['findSimilarHomes'].value;
      const sellAPropertyChecked = this.contactForm.controls['sellAProperty'].value;

      if ((sellAPropertyChecked && findSimilarHomesChecked) || requestMoreInfoChecked) {
        this.contactForm.patchValue({ comments: requestMoreInfoMessage });
      } else if (sellAPropertyChecked) {
        this.contactForm.patchValue({ comments: sellAPropertyMessage });
      } else if (findSimilarHomesChecked) {
        this.contactForm.patchValue({ comments: findSimilarHomesMessage });
      } else {
        this.contactForm.patchValue({ comments: requestMoreInfoMessage });
      }
    }
  }

  private _selectCommentMessageForViewing(forceOverride: boolean = false) {
    const scheduleAViewingMessage = this._contactFormMessages[0];
    const availability = this._contactFormMessages[1];
    const weekdayAvailability = this._contactFormMessages[2];
    const weekendAvailability = this._contactFormMessages[3];
    const andAvailability = this._contactFormMessages[4];
    // construct our default message
    const availabilityMessage = scheduleAViewingMessage +
      ((this.isWeekdaysAvailable() || this.isWeekendsAvailable()) ? availability : '') +
      ((this.isWeekdaysAvailable() ? weekdayAvailability : '') + this.dailyAvailability('weekdays')) +
      (this.isWeekdaysAvailable() && this.isWeekendsAvailable() ? andAvailability : '') +
      ((this.isWeekendsAvailable() ? weekendAvailability : '') + this.dailyAvailability('weekends')) +
      ((this.isWeekdaysAvailable() || this.isWeekendsAvailable()) ? '.' : '') ;
    const currentMessage = this.contactForm.controls['comments'].value;

    // the message in the box is one of the default messages
    if (forceOverride || (!currentMessage || currentMessage.includes(scheduleAViewingMessage))) {
      this.contactForm.patchValue({ comments: availabilityMessage});
    }
  }

  private dailyAvailability(weektype: string) {
    const morning = this._contactFormMessages[5];
    const aftrenoon = this._contactFormMessages[6];
    const evening = this._contactFormMessages[7];
    const dailyAndAvailability = this._contactFormMessages[8];
    let availability;
    if (weektype === 'weekdays') {
      availability = (( this.contactForm.controls['weekdayMorning'].value ? morning : '') +
      (this.contactForm.controls['weekdayAfternoon'].value ? aftrenoon : '') +
      (this.contactForm.controls['weekdayEvening'].value ? evening : '')).replace(/,\s*$/, '');
    }
    else if (weektype === 'weekends') {
      availability = (( this.contactForm.controls['weekendMorning'].value ? morning : '') +
      (this.contactForm.controls['weekendAfternoon'].value ? aftrenoon : '') +
      (this.contactForm.controls['weekendEvening'].value ? evening : '')).replace(/,\s*$/, '');
    }
    const commaIndex = availability.lastIndexOf(',');
    if  (commaIndex > -1) {
      availability = [availability.slice(0, commaIndex), dailyAndAvailability, availability.slice(commaIndex + 1)].join('');
    }
    return availability;
  }

  private isWeekdaysAvailable() {
    return  this.contactForm.controls['weekdayMorning'].value  ||
            this.contactForm.controls['weekdayAfternoon'].value ||
            this.contactForm.controls['weekdayEvening'].value ;
  }

  private isWeekendsAvailable() {
    return  this.contactForm.controls['weekendMorning'].value ||
            this.contactForm.controls['weekendAfternoon'].value  ||
           this.contactForm.controls['weekendEvening'].value;
  }

  // Go through the external javascript files needed for the listing details page and start loading them.
  private _loadScripts(): void {
    this.domManipulationService.loadScript(LOCALLOGIC_SCRIPT);
    this.domManipulationService.loadScript(CLIPBOARD_SCRIPT);
  }

  private async _setListingDetails(listing: Listing) {
    this.listing = listing;
    this.centerLatLng = {
      lat: listing.lat,
      lng: listing.lng
    };
    this.suggestedListingSearchUrl =  `/${listing.province.toLowerCase()}/${listing.city.replace(/\s/g, '-').toLowerCase()}-real-estate`;

    if (!this.listing.isOffMarket) {
      await this.createMetaDataTags(
        'meta-tags.listing-details.title',
        'meta-tags.listing-details.description',
        { address: this.listing.fullAddress, id: this.listing.listingId },
        { description: this.listing.description }
      );
    } else {
      const address = this.titlecasePipe.transform(this.listing.address);
      const city = this.titlecasePipe.transform(this.listing.city);
      const province = this.listing.province.toLowerCase();

      await this.createMetaDataTags(
        'meta-tags.off-market-listing-details.title',
        'meta-tags.off-market-listing-details.description',
        {
          address: address,
          city: city,
          province: province,
          postalCode: this.listing.postalCode
        },
        {
          address: this.titlecasePipe.transform(this.listing.address),
          city: this.titlecasePipe.transform(this.listing.city),
          province: '' + province,
          postalCode: this.listing.postalCode
        }
      );
    }

    this.showMap = false;
    this.prerenderService.setPreRenderFlag(200);
    // Make sure its at the top of the page on load
    this.domManipulationService.scrollToTop();
    this._updateAgentInformation();
    this._getSuggestedListings();

    // Set up all off the various detail data rows
    this.hasCopiedText = false;

    this.isCreaListing = listing.source === CreaBoardName;
    this.isEdmontonBoard = listing.source === EdmontonSource;
    this.setPriceOrPricePerSqFt();
    if (!this.listing.isOffMarket) {
      this._setCommentsMessage();
    } else {
      this._setCommentsMessageForOffMarket();
    }

    // Calculate if mortgage is applicable to the property or not
    this.isMortgageApplicable = (!this.listing.isLeaseOrRental && this.listing.listPrice > 5000) &&
      (ListingTypeMap.commercial.indexOf(this.listing.listingTypeId) === -1);

    // this.isLoading = true;
      this.historyService.push(new HistoryItem({ listingId: listing.id, detailUrl: listing.detailUrl }));

    // Other Services
    this.communicationService.listings.listingCategory.next(listing.isLuxury ? ListingCategory.LUXURY : listing.isCommercial ? ListingCategory.COMMERCIAL : ListingCategory.RESIDENTIAL);

    this._preferencesService.addViewedListing(listing.id);
    // Set up the listings that the user can navigate to via the next and prev buttons
    this._preferencesService.nextListingsChanged.pipe(take(1)).toPromise().then(async (listings) => {
      this.nextListings = listings;
      this._nextListingsOffset = listings.map(l => l.listingId).indexOf(listing.id);
      if (this._nextListingsOffset + 1 >= this.nextListings.length) await this._getMoreListings();
      this.hasMoreListings = this.nextListings.length > 1 && (this._nextListingsOffset + 1 < this.nextListings.length);
    });

    this.listingService.populateListingRowInfo(this.listing);
    this.isLoading = false;

    this.disableSellersLeadForm = this.listing.isOffMarket && DisableSellersLeadFormStateShorts.includes(listing.province.toUpperCase());
  }

  imgErrorHandler(event) {
    this.shouldShowInitials = true;
  }

  goToNearbyListingsSearch() {
    this._preferencesService.setPosition(
      this.listing.lat, this.listing.lng, 16
    );
    this.communicationService.searchParametersChanged.next();
    this._analyticsService.eventTrack(OFFMARKET_SEARCH_MORE, null);

    this.router.navigate(['/find-real-estate']);
  }

  async createMetaDataTags(titleString: string, descriptionString: string, titleVariables: any, descriptionVariables: any) {
    this.metaTagService.setPageTitle(titleString, titleVariables);
    this.metaTagService.setPageDescription(descriptionString, descriptionVariables);

    titleVariables['province'] = await this.translateService.get(`provinces.${this.listing.province.toLowerCase()}`).toPromise();
    descriptionVariables['province'] = await this.translateService.get(`provinces.${this.listing.province.toLowerCase()}`).toPromise();

    const openGraphTags: any = [
      {
        name: 'title',
        content: titleString,
        variables: titleVariables,
        isTranslateKey: true
      },
      {
        name: 'description',
        content: descriptionString,
        variables: descriptionVariables,
        isTranslateKey: true
      },
      {
        name: 'image',
        content: this.listing.imageUrls.length ? this.listing.imageUrls[0] : this.listing.placeHolderImage
      },
      {
        name: 'details',
        content: JSON.stringify(this.listing.openGraphContent)
      },
      {
        name: 'latitude',
        content: '' + this.listing.lat,
        prefixName: 'place:location'
      },
      {
        name: 'longitude',
        content: '' + this.listing.lng,
        prefixName: 'place:location'
      },
      {
        name: 'type',
        content: 'place'
      }
    ];

    this.metaTagService.setOpenGraphTags(openGraphTags);
  }

  homeEstimateLink($event) {
    this.router.navigate(['/home-estimates-canada']);
  }

  updateMortgatePayment($event: string) {
    // mortgate update was taking place after/during view init causing expressionerror
    setTimeout(() => {
      this.mortgagePaymentAmount = $event;
    })
  }
}
